const BagIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9146 3.9001C10.2025 3.9001 8.81463 5.28801 8.81463 7.0001H7.01463C7.01463 4.2939 9.20843 2.1001 11.9146 2.1001C14.6208 2.1001 16.8146 4.2939 16.8146 7.0001H15.0146C15.0146 5.28801 13.6267 3.9001 11.9146 3.9001Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2322 8.8001H6.46017C6.35296 8.8001 6.26482 8.88463 6.26034 8.99174L5.80021 19.9917C5.79546 20.1054 5.8863 20.2001 6.00004 20.2001H17.8073C17.9219 20.2001 18.013 20.1041 18.007 19.9897L17.4319 8.98965C17.4263 8.8834 17.3386 8.8001 17.2322 8.8001ZM6.46017 7.0001C5.38811 7.0001 4.50672 7.84539 4.46191 8.91651L4.00178 19.9165C3.95425 21.0529 4.86267 22.0001 6.00004 22.0001H17.8073C18.9529 22.0001 19.8644 21.0397 19.8046 19.8957L19.2294 8.89567C19.1739 7.83313 18.2961 7.0001 17.2322 7.0001H6.46017Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.41756 10.4165C8.83192 10.142 9.39038 10.2553 9.66492 10.6697C10.1066 11.3363 10.8431 12.03 11.6044 12.217C11.9539 12.3029 12.3195 12.2868 12.7145 12.0964C13.1245 11.8988 13.6248 11.4841 14.1644 10.6697C14.439 10.2553 14.9974 10.142 15.4118 10.4165C15.8261 10.6911 15.9395 11.2495 15.6649 11.6639C15.0046 12.6605 14.2799 13.3401 13.4961 13.7178C12.6973 14.1029 11.9004 14.1433 11.1749 13.9651C9.78628 13.6239 8.72271 12.5065 8.16441 11.6639C7.88987 11.2495 8.00321 10.6911 8.41756 10.4165Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default BagIcon
